<template>
  <div>
    <div class="tag" v-if="isPc">
      <div class="tag-content">
        <div v-for="(tag, index) in tagList" :key="index">
          <a-tag
            style="margin-top: 5px;cursor:pointer"
            :color="tag.selected ? 'red' : ''"
            :closable="tag.uid === userInfo.id"
            @click="selecteTag(tag)"
            @close="deleteTag(tag, $event)"
          >{{tag.name}}</a-tag>
        </div>
      </div>
      <div style="flex: 0 0 60px">
        <a-button
          type="primary"
          size="small"
          ghost
          @click="modalVisible = true"
        >
          {{'+ ' + $t('publish.tagAdd')}}
        </a-button>
      </div>
    </div>

    <div v-else>
      <div class="top-title">
        <span>{{$t('publish.workTag.label')}}</span>
        <div style="flex: 0 0 60px">
          <a-button
            type="primary"
            size="small"
            ghost
            @click="modalVisible = true"
          >{{'+ ' + $t('publish.tagAdd')}}</a-button>
        </div>
      </div>
      <div class="tag-content">
        <div v-for="(tag, index) in tagList" :key="index">
          <a-tag
            style="margin-top: 5px;cursor:pointer"
            :color="tag.selected ? 'red' : ''"
            :closable="tag.uid === userInfo.id"
            @click="selecteTag(tag)"
            @close="deleteTag(item, $event)"
          >{{tag.name}}</a-tag>
        </div>
      </div>
    </div>
    <HTagModal :type="type" :visible="modalVisible" @close="modalVisible = false" @handleConfirm="addTag"></HTagModal>
  </div>
</template>

<script>
import { getTag, deleteTag } from "@/api/publish";
import HTagModal from "./components/HTagModal";
import { mapGetters } from "vuex";

export default {
  components: { HTagModal },
  props: {
    defaultValue: {
      type: Array,
      default: () => [],
    },
    isPc: {
      default: true,
      type: Boolean,
    },
    type:{
      type: Number,
      default: 0,
    }
  },
  data() {
    return {
      modalVisible: false,
      tagList: [],
      // selectedtags: [],
    };
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  mounted() {
    getTag({ type: this.type, filter: "all" }).then((res) => {
      this.handleTagList(res.data);
    });
  },
  methods: {
    handleTagList(data) {
      if (data && data.length > 0) {
        let newList = [];
        for (let i = 0; i < data.length; i++) {
          const item = data[i];
          const tagItem = { selected: false, ...item };
          newList.push(tagItem);
        }
        this.tagList = newList;
        if (this.defaultValue.length) {
          this.setTagSelected(this.defaultValue);
        }
      }
    },
    setTagSelected(tagSelectedList) {
      this.tagList.forEach((item) => {
        if (tagSelectedList.includes(item.id)) {
          item.selected = true;
        }
      });
    },
    addTag(newtag, newList) {
      console.log(newtag, newList);
      this.modalVisible = false;
      let tagWithId = newList.filter((item) => item.name === newtag.name)[0];
      tagWithId.selected = true;
      this.tagList.push(tagWithId);
      const selected = this.getSelectedTag();
      this.$emit("updateTagData", selected);
    },
    deleteTag(item, event) {
      event.preventDefault();
      const { id } = item;
      const key = "tag-delete-key";
      this.$message.loading({ content: this.$t('message.deleteLoading')+"...", key });
      deleteTag({ id })
        .then((res) => {
          this.$message.success({ content: this.$t('message.deleteSuccess'), key, duration: 1 });
          //本地刪除
          const index = this.tagList.findIndex((item) => item.id === id);
          if (index > 0) {
            this.$delete(this.tagList, index);
            this.selecteTag(item)
          }
        })
        .catch((err) => {
          this.$message.error({ content: this.$t('message.deleteFail'), key, duration: 1 });
        });
    },
    selecteTag(tag) {
      tag.selected = !tag.selected;
      const selected = this.getSelectedTag();
      this.$emit("updateTagData", selected);
    },
    getSelectedTag() {
      const selected = [];
      if (this.tagList && this.tagList.length > 0) {
        for (let i = 0; i < this.tagList.length; i++) {
          if (this.tagList[i].selected) {
            selected.push(this.tagList[i].id);
          }
        }
      }
      return selected;
    },
  },
};
</script>

<style lang="less" scoped>
.tag {
  display: flex;
  justify-content: space-between;
  .tag-content {
    max-width: 300px;
    max-height: 125px;
    overflow: auto;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
  .addBtn {
    border-color: #d485ff;
    color: #d485ff;
  }
}

@media screen and (max-width: 768px) {
  .top-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: white;
  }
  .tag-content {
    width: 100%;
    max-height: 125px;
    overflow: auto;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;
    padding: 10px 0;
  }
}
</style>